import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from "@angular/common";
import {EasternTimePipe} from "@irb-common/pipes/EasternTimePipe";
import {AppService} from "@irb/app.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {IrbAgGridExportService} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";
import {MmcModelHistoryGridLayoutService} from "@irb/irb-editors/editor-mmc-model/mmc-model-history/mmc-model-history.grid-layout.service";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {EditorMmcModelService} from "@irb/irb-editors/editor-mmc-model/editor-mmc-model.service";

@Component({ standalone: false,
    selector: 'irb-mmc-model-history',
    templateUrl: './mmc-model-history.component.html',
    styleUrls: ['./mmc-model-history.component.scss'],
    providers: [DatePipe, EasternTimePipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MmcModelHistoryComponent implements OnInit, OnDestroy {
    faDownload = faDownload;
    rowCount: number;
    gridOptions: any;
    sideBar: any;
    private grid: any;
    private _data: any;
    isUiTest = false;
    frameworkComponents: any;
    @Input()
    set data(value: any) {
        this._data = value;
        this.load();
    }

    get data() {
        return this._data;
    }

    @Input() eventModelType: string;

    constructor(private mmcModelgls: MmcModelHistoryGridLayoutService,
                private as: AppService,
                protected ies: IrbEditorsService,
                public ges: IrbAgGridExportService,
                private editorMmcModelService: EditorMmcModelService,
                private datePipe: DatePipe,
                private easternTimePipe: EasternTimePipe) {
    }

    ngOnInit(): void {
        let colDef = this.mmcModelgls.getColumnDefs();
        this.gridOptions = {            
            columnDefs: colDef,
            context: {componentParent: this},
            floatingFilter: false,
            suppressHorizontalScroll: true
        };
        
        this.frameworkComponents = this.mmcModelgls.getFrameworkComponents();
    }

    load() {
        if (this.data && this.grid) {
            this.grid.api.setGridOption('rowData', this.data);
            this.rowCount = (this.data) ? this.data.length : 0;}
    }

    onGridReady(params: any) {
        this.grid = params;
        this.load();
    }

    ngOnDestroy() {
    }
    exportModelHistory() {
        let colDef = this.mmcModelgls.getColumnDefs();
        const formatter = (res: any[]) => {
            res.forEach((r: any) => {
                if(r.modifiedOn) {
                    r.modifiedOn = this.datePipe.transform(this.easternTimePipe.transform(Number(r.modifiedOn)), 'MM/dd/yyyy h:mm a') + ' ET';
                }
                if (r.securityDescription) {
                    r.securityDescription = r.securityDescription.includes(",") ? "\"" + r.securityDescription + "\"" : r.securityDescription;
                }
            });
            return res;
        };
        //get the data in sorted order
        let exportSortedData: any[] = [];
        this.grid.api.forEachNodeAfterFilterAndSort((node: any) => {
            exportSortedData.push(node.data);
        });
        let result = JSON.parse(JSON.stringify(exportSortedData));
        this.ges.setPrefix("Model_History", "csv");
        this.ges.setExportOptions(formatter(result), this.grid.api, this.gridOptions,colDef);
    }
}
